import { Component, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { Loading } from '../../components/loading/loading';

@Component({
  selector: 'app-dev',
  imports: [Loading],
  templateUrl: './dev.html',
  styleUrl: './dev.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class Dev {
  loading = false;

  constructor() {}

  teste() {
    this.loading = false;
  }
}
